import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModalContainer from 'pluton-core/lib/containers/pages/service/Modal.container';
import Footer from '../../components/controls/footer/Footer.jsx';

import { loginModel } from 'pluton-core/lib/models/auth/login.model';
import { errorModel } from 'pluton-core/lib/models/service/error.model';
import { controlModel } from 'pluton-core/lib/models/core/control.model';
import { modelGet, modelActionCall } from '../../actions/model.actions';
import { isFooterVisible } from 'pluton-core/lib/utils/helpers';
import * as modalActions from 'pluton-core/lib/actions/model.actions'


class MainLayout extends Component {

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.auth.isAuth && this.props.auth.isAuth) {
            this._loadControls();
        }

        if (prevProps.auth.isAuth && !this.props.auth.isAuth) {
            this._clearControls();
        }
    }

    _loadControls = () => {
        if (!this.props.controls.isLoading) {
            this.props.handleGetControls();
        }
    };

    _clearControls = () => {
        this.props.handleClearControls();
    };

    renderFooter = () => {
        if (!this.props.auth.isAuth || this.props.isErrors || !isFooterVisible(this.props.location.pathname)) {
            return null;
        }

        return (
            <Footer {...this.props} />
        );
    };

    render() {
        const { children } = this.props;
        return (
            <div>
                <ModalContainer modal={this.props.modal} actions={this.props.modalActions}/>
                {children}
                {this.renderFooter()}
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    const errors = state.error[errorModel.MODEL_NAME];
    const isErrors = errors.isNetworkError;

    return {
        auth: state.auth[loginModel.MODEL_NAME],
        modal: state.modal,
        controls: state.control[controlModel.MODEL_NAME],
        isErrors
    };
};
//TODO now in batch
const mapDispatchToProps = (dispatch) => {
    return {
        handleGetControls: bindActionCreators(modelGet(controlModel), dispatch),
        handleGetControlsSumPower: bindActionCreators(modelActionCall(controlModel, controlModel.apiGetDevicesPowerSum), dispatch),
        handleGetControlsStatus: bindActionCreators(modelActionCall(controlModel, controlModel.apiGetDevicesStatus), dispatch),
        handleClearControls: bindActionCreators(controlModel.actionClear.bind(null, controlModel), dispatch),
        modalActions: bindActionCreators({
            ...modalActions
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);



// WEBPACK FOOTER //
// ./app/containers/layouts/Main.layout.jsx